import {DefaultRootState, useSelector} from 'react-redux';
import {SettingsToggles} from './config-types';

export function useTagsWithConfirmation() {
    return useSelector((state: DefaultRootState) => state.config.uiConfig.search.tagsWithConfirmation);
}

export function useTagDropdownOptions() {
    return useSelector((state: DefaultRootState) => state.config.uiConfig.search.tagDropdownOptions);
}

export function useDetailFields() {
    return useSelector((state: DefaultRootState) => state.config.uiConfig.search.detailFields);
}

export function useSpotlightTagTypes() {
    return useSelector((state: DefaultRootState) => state.config.uiConfig.search.spotlightTagTypes);
}

export function useSharedSavedSearchesEnabled() {
    return useSelector((state: DefaultRootState) => state.config.uiConfig.sharedSavedSearches.enabled);
}

export function useSettingsConfig(): {enabled: boolean; toggles: SettingsToggles} {
    return useSelector((state: DefaultRootState) => state.config.uiConfig.settings);
}

export function useSettingsTogglesConfig(): SettingsToggles {
    return useSelector((state: DefaultRootState) => state.config.uiConfig.settings.toggles);
}

export function useAiAssistantWebsearchEnabled(): boolean {
    return useSelector((state: DefaultRootState): boolean => state.config.uiConfig.aiAssistant.websearchEnabled);
}

export function useAiAssistantSupportedTags() {
    return useSelector((state: DefaultRootState) => state.config.uiConfig.aiAssistant.supportedTags);
}

export function useAiAssistantHelpModalContentGerman() {
    return useSelector((state: DefaultRootState) => state.config.uiConfig.aiAssistant.helpModalContentGerman);
}

export function useAiAssistantHelpModalContentEnglish() {
    return useSelector((state: DefaultRootState) => state.config.uiConfig.aiAssistant.helpModalContentEnglish);
}
